import { object } from "prop-types";
import React, { useEffect, useState } from "react";
import BigSectionHeroImage from "../../../../components/story-templates/big-section-hero-image";
import { SeriesPageTabComponent } from "../SeriesPageTabComponent";
import "../../../../components/pages/section.m.css";
import "../OneBigThreeSmallSectionLayout/one-big-three-small-section-layout.m.css";
import "./series-page.m.css";
import { useSelector } from "react-redux";
import get from "lodash/get";

const SeriesPageLayout = ({ data }) => {
  return (
    <div styleName="container" style={{padding: "0"}}>
      <div styleName="main-contents">
        <React.Fragment>
          <div styleName="wrapper black" className="one-big-three-small-section-layout-wrapper">
            <div styleName="">
              <div styleName="container-wrapper">
                  <div styleName="big-img">
                    <BigSectionHeroImage
                      data={data}
                    />
                    <SeriesPageTabComponent
                      data={data}
                    />
                  </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      </div>
    </div>
  );
}

SeriesPageLayout.propTypes = {
  data: object
};

export { SeriesPageLayout };
